module.exports = __webpack_public_path__ + "img/audio-icon.666bae9a.svg";